import { render, staticRenderFns } from "./send-red-packet.vue?vue&type=template&id=691161b6&scoped=true"
import script from "./send-red-packet.vue?vue&type=script&lang=js"
export * from "./send-red-packet.vue?vue&type=script&lang=js"
import style0 from "./send-red-packet.vue?vue&type=style&index=0&id=691161b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691161b6",
  null
  
)

export default component.exports